// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Env = require("../../../reason/common/Env.bs.js");
let Loader = require("../../../uikit/reason/atoms/Loader/Loader.bs.js");
let Theme__Color = require("../../../reason/common/Theme/Theme__Color.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let ReactGoogleMaps = require("../../bindings/ReactGoogleMaps.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../ErrorHandling/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ReactGoogleMaps$1 = require("@vis.gl/react-google-maps");
let UnselectedUnionMemberError = require("../ErrorHandling/UnselectedUnionMemberError.bs.js");
let PropertyLocationMap_property_graphql = require("../../../__generated__/PropertyLocationMap_property_graphql.bs.js");
let PropertyLocationMapInner_location_graphql = require("../../../__generated__/PropertyLocationMapInner_location_graphql.bs.js");

let googleKey = Stdlib_Option.getOrThrow(Env.google_key, undefined);

function PropertyLocationMap$GoogleMap$Inner(props) {
  let __size = props.size;
  let size = __size !== undefined ? __size : "large";
  let isLoaded = ReactGoogleMaps$1.useApiIsLoaded();
  if (isLoaded) {
    return JsxRuntime.jsx(ReactGoogleMaps$1.Map, {
      className: "flex-grow relative",
      defaultCenter: {
        lat: props.lat,
        lng: props.lon
      },
      defaultZoom: 14,
      options: {
        controlSize: size === "medium" ? 24 : undefined
      },
      children: props.children
    });
  } else {
    return JsxRuntime.jsx(Loader.make, {});
  }
}

let Inner = {
  make: PropertyLocationMap$GoogleMap$Inner
};

function PropertyLocationMap$GoogleMap(props) {
  let __size = props.size;
  let size = __size !== undefined ? __size : "large";
  let heightPx = size === "medium" ? "h-[380px]" : "h-[480px]";
  return JsxRuntime.jsx(ReactGoogleMaps$1.APIProvider, {
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(PropertyLocationMap$GoogleMap$Inner, {
        lat: props.lat,
        lon: props.lon,
        size: size,
        children: props.children
      }),
      className: heightPx + " flex items-stretch justify-center relative"
    }),
    apiKey: googleKey
  });
}

let GoogleMap = {
  googleKey: googleKey,
  Inner: Inner,
  make: PropertyLocationMap$GoogleMap
};

let convertFragment = PropertyLocationMapInner_location_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyLocationMapInner_location_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyLocationMapInner_location_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyLocationMapInner_location_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyLocationMapInner_location_graphql.node, convertFragment, fRef);
}

let PropertyLocationFragment_visibilityReason_decode = PropertyLocationMapInner_location_graphql.Utils.visibilityReason_decode;

let PropertyLocationFragment_visibilityReason_fromString = PropertyLocationMapInner_location_graphql.Utils.visibilityReason_fromString;

let PropertyLocationFragment = {
  visibilityReason_decode: PropertyLocationFragment_visibilityReason_decode,
  visibilityReason_fromString: PropertyLocationFragment_visibilityReason_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyLocationMap$FromPropertyLocation(props) {
  let size = props.size;
  let propertyLocation = RescriptRelay_Fragment.useFragment(PropertyLocationMapInner_location_graphql.node, convertFragment, props.propertyLocation);
  let lat;
  let lon;
  switch (propertyLocation.__typename) {
    case "PropertyLocationWithHiddenAddress" :
      let match = propertyLocation.approximateCoordinates;
      lat = match.lat;
      lon = match.lon;
      break;
    case "PropertyLocationWithVisibleAddress" :
      let match$1 = propertyLocation.visibilityRule;
      let match$2 = propertyLocation.coordinates;
      let lon$1 = match$2.lon;
      let lat$1 = match$2.lat;
      let exit = 0;
      if (match$1 === "VISIBLE_TO_ACCOUNT_MEMBER") {
        lat = lat$1;
        lon = lon$1;
      } else {
        exit = 2;
      }
      if (exit === 2) {
        return JsxRuntime.jsx(PropertyLocationMap$GoogleMap, {
          lat: lat$1,
          lon: lon$1,
          size: size,
          children: JsxRuntime.jsx(ReactGoogleMaps$1.Marker, {
            position: {
              lat: lat$1,
              lng: lon$1
            }
          })
        });
      }
      break;
    case "__unselected" :
      return UnselectedUnionMemberError.raise(`Unselected propertyLocation: ` + propertyLocation._0);
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(PropertyLocationMap$GoogleMap, {
        lat: lat,
        lon: lon,
        size: size,
        children: JsxRuntime.jsx(ReactGoogleMaps.Circle.make, {
          center: {
            lat: lat,
            lng: lon
          },
          radius: 1000,
          fillColor: Theme__Color.toString(Theme__Color.youtube),
          fillOpacity: 0.15,
          strokeColor: Theme__Color.toString(Theme__Color.youtube),
          strokeOpacity: 0.85,
          strokeWeight: 2
        })
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("span", {
          children: "To protect seller privacy, location is approximate",
          className: "text-sm"
        }),
        className: "pt-1 pl-1"
      })
    ]
  });
}

let FromPropertyLocation = {
  PropertyLocationFragment: PropertyLocationFragment,
  make: PropertyLocationMap$FromPropertyLocation
};

let convertFragment$1 = PropertyLocationMap_property_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyLocationMap_property_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyLocationMap_property_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyLocationMap_property_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyLocationMap_property_graphql.node, convertFragment$1, fRef);
}

let PropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyLocationMap$WithoutErrorBoundary(props) {
  let property = RescriptRelay_Fragment.useFragment(PropertyLocationMap_property_graphql.node, convertFragment$1, props.property);
  return JsxRuntime.jsx(PropertyLocationMap$FromPropertyLocation, {
    propertyLocation: property.propertyLocation.fragmentRefs,
    size: props.size
  });
}

let WithoutErrorBoundary = {
  make: PropertyLocationMap$WithoutErrorBoundary
};

function PropertyLocationMap(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "map",
    children: JsxRuntime.jsx(PropertyLocationMap$WithoutErrorBoundary, {
      property: props.property,
      size: props.size
    })
  });
}

let make = PropertyLocationMap;

exports.GoogleMap = GoogleMap;
exports.FromPropertyLocation = FromPropertyLocation;
exports.PropertyFragment = PropertyFragment;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* googleKey Not a pure module */
